module.exports = __webpack_public_path__ + "img/banner-01.f4c36e61.jpg";